import React from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import { CloseCircle} from "../../icons"
import StructuredText from "../custom-structured-text-renderer";
import { Link } from "../../../../plugins/gatsby-plugin-atollon";

const ThankYou = ({title, richContent, theme}) => {

  let brandSlug
  if (theme) {
    switch (theme) {
      case 'bone':
        brandSlug = 'bone-roasters'
        break
      case 'greenwheat':
        brandSlug = 'greenwheat-freekeh'
        break
      default:
        brandSlug = theme
    }
  }

    return (
        <section className={`sample ${theme || ''}`}>
            <div className='sample__inner'>
                <button className='sample__close' onClick={() => window.history.back()}>
                  <CloseCircle/>
                </button>
                <div className='sample__details'>
                    <div className='sample__content' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                        {title && <h1>{parse(title)}</h1>}
                        {richContent && <div><StructuredText data={richContent}/></div>}
                        <Link className='btn' to={`/${brandSlug || '/'}`}>Head Home</Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ThankYou

export const query = graphql`
fragment ThankYouProps on DatoCmsThankYou {
  ... on DatoCmsThankYou {
    id
    title
    richContent {
      value
    }
  }
}
`